export default "__VITE_ASSET__a8fc69de__"